import { Html } from '@react-three/drei'
import { HtmlProps } from '@react-three/drei/web/Html'
import { Vector3 } from 'three'
import { useDistanceDimensions } from '~/hooks/useDistanceDimensions'
import { Dimension } from '~/store/objects/types'

const LABEL_CLASSES =
  'w-fit whitespace-nowrap bg-white text-xs rounded tabular-nums px-2 py-1 outline outline-1 outline-gray-300'

export function Label(props: { label: Dimension } & HtmlProps) {
  const { displayFormattedValue } = useDistanceDimensions()

  const { label, ...rest } = props
  const formatted = displayFormattedValue(new Vector3().subVectors(label.startPos, label.endPos).length())

  return (
    <Html center style={{ pointerEvents: 'none' }} {...rest}>
      <div className={LABEL_CLASSES}>{formatted}</div>
    </Html>
  )
}
